import { render } from "./Announcements.vue?vue&type=template&id=276ae217&scoped=true"
import script from "./Announcements.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./Announcements.vue?vue&type=script&charset=utf-8&lang=js"

import "./Announcements.vue?vue&type=style&index=0&id=276ae217&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276ae217"]])

export default __exports__